import { render, staticRenderFns } from "./FinanceSalarySliceTableItem.vue?vue&type=template&id=238e86c7&scoped=true&"
import script from "./FinanceSalarySliceTableItem.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceTableItem.vue?vue&type=script&lang=js&"
import style0 from "./FinanceSalarySliceTableItem.vue?vue&type=style&index=0&id=238e86c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e86c7",
  null
  
)

export default component.exports